import { Capacitor } from '@capacitor/core';
import { TextZoom } from '@capacitor/text-zoom';

// iOS accessibility sizes go up to ~3x; past 1.5x the fixed-height cards and
// buttons start clipping, so cap it there until those layouts are reworked.
const MAX_ZOOM = 1.5;

/**
 * Apply the iPhone's Text Size setting (Settings > Display > Text Size) to the
 * web view. On iOS this sets -webkit-text-size-adjust on <body>, which scales
 * px font sizes too. No-op on the web.
 */
export async function applyPreferredTextZoom(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { value } = await TextZoom.getPreferred();
    await TextZoom.set({ value: Math.min(value, MAX_ZOOM) });
  } catch (err) {
    console.warn('[textZoom] could not apply preferred text size', err);
  }
}
